module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/glass-half-full/glass-half-full.component.scss
// module id = 767
// module chunks = 0